import Swiper from "swiper";
import { Autoplay } from "swiper";


const slider = document.querySelector('.professionalsSwiper');
const sliderWrapper = slider.querySelector(".swiper-wrapper");
let sliderItems = slider.querySelectorAll(".swiper-slide");

if (sliderWrapper && sliderItems.length > 0) {
    let slidesCount = sliderItems.length;

    if (slidesCount <= 8) {
        let repeat = Math.ceil((8 / slidesCount) * 2);
        if (repeat > 0) {
            for (let i = 0; i < repeat; i++) {
                sliderItems.forEach((item) => {
                    const swiperItemNew = document.createElement("div");
                    swiperItemNew.classList.add("swiper-slide");
                    swiperItemNew.innerHTML = item.innerHTML;
                    sliderWrapper.append(swiperItemNew);
                });
            }
        }
    }

    new Swiper(slider, {
        modules: [ Autoplay],
        direction: "vertical",
        spaceBetween: 18,
        loop: true,
        slidesPerView: "auto",
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        on: {
            init() {
                animateSlides(this);
            },
            setTranslate() {
                animateSlides(this);
            }
        }
    });
    function animateSlides(swiper) {
        const containerRect = swiper.el.getBoundingClientRect();
        const H = containerRect.height;      // 800
        const centerOffset = 100; // 🔥 крутиш це
        const center = H / 2 + centerOffset;
        const range = 350;                   // як ти сказав

        swiper.slides.forEach(slide => {
            const rect = slide.getBoundingClientRect();

            const slideCenter = rect.top + rect.height / 2 - containerRect.top;

            let translateX = 0;

            // 🔽 НИЗ → ЦЕНТР (0 → -100)
            if (slideCenter >= center && slideCenter <= center + range) {
                const p = (center + range - slideCenter) / range; // 0 → 1
                translateX = -100 * p;
            }

            // 🔼 ЦЕНТР → ВГОРУ (-100 → 0)
            else if (slideCenter < center && slideCenter >= center - range) {
                const p = (center - slideCenter) / range; // 0 → 1
                translateX = -100 * (1 - p);
            }

            // інше — 0

            // 🎯 ACTIVE тільки в центрі
            if (Math.abs(slideCenter - center) < 40) {
                slide.classList.add('active');
            } else {
                slide.classList.remove('active');
            }

            slide.style.transform = `translateX(${translateX}px)`;
        });
    }
}
